<template>
    <div id="app">
        <div class="content">
            <div id="experience_container" v-bind:class="{ 'player-loading': !isPlayerVisible }">
                <div class="left-side">
                    <DynamicPanels username="David J. Smith" v-bind:curDate="curDate" v-bind:curTime="curTime" />
                </div>
                <div class="right-side">
                    <div class="right-top">
                        <SessionTracker />
                    </div>
                    <div class="right-bottom">
                        <div id="player-container"></div>
                        <div id="scv_container"></div>
                    </div>
                </div>
                <ConversationView />
                <div class="overlays" v-if="!cbLoaded || !experienceStarted">
                    <div class="loading" v-if="!cbLoaded">
                        <div class="loading-wheel">
                            <div class="spinner"></div>
                        </div>
                    </div>
                    <div class="click-to-play" v-if="!experienceStarted && cbLoaded">
                        <div class="start-btn" v-on:click="startExperience">
                            <i class="fa fa-play"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer>
            <img src="./assets/images/ida-white.png" alt="iDAvatars" width="120px">
        </footer>
    </div>
</template>
<script>
// @ is an alias to /src
import DynamicPanels from '@/components/DynamicPanels.vue'
import SessionTracker from '@/components/SessionTracker.vue'
import ConversationView from '@/components/ConversationView.vue'
import $ from 'jquery'

export default {
    mounted: function() {
        vidbaby.player.build('#player-container');
        vidbaby.$(document).on('na-ready.vidbaby', (event, data) => {
            this.isPlayerVisible = true;
        });
    },
    data: function() {
        var date = new Date();
        return {
            isPlayerVisible: false,
            cbLoaded: true,
            experienceStarted: false,
            curDate: date.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),//'Tuesday, January 18, 2019',
            curTime: date.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: false })//'16:40'
        }   
    },
    methods: {
        startExperience: function() {
            vidbaby.$(document).trigger('na-ask.vidbaby', '<<start>>');
            this.experienceStarted = true;
        }
    },
    components: {
        DynamicPanels,
        SessionTracker,
        ConversationView
    }
}
</script>
<style lang="stylus">
@keyframes rotate
    0%
        trasform: rotate(0deg)
    50%
        transform: rotate(180deg)
    100%
        transform: rotate(360deg)

body
    background #363636
    margin: 0
    padding: 0
#app
    font-size: 16px
    font-family Helvetica, Arial, sans-serif
    text-align center
    color #fff
    padding: 1em 0
.content
    background: url('./assets/images/bg-darkened.jpg') center/cover no-repeat
#experience_container
    margin: 1em auto
    width: 1230px
    height: 600px
    display: flex
    position: relative
    &.player-loading
        .right-bottom
            #cb_player_container
                background: url('./assets/images/loadingImage_Base.png') center/cover no-repeat
    .left-side
        flex: 1
        padding: 9px 73px 19px 55px
    .right-side
        display: flex
        flex-direction: column
        width: 500px
        .right-top
            flex: 1
        .right-bottom
            height: 450px
            position: relative
            #cb_player_container
                width: 380px
                height: 450px
                position: relative
                .vidbaby-player
                    position: relative !important
            #scv_container
                position: absolute
                right: 0
                top: 40%
    .overlays
        position: absolute
        top: 0
        left: 0
        right: 0
        bottom: 0
        background: rgba(0,0,0,0.5)
        z-index: 100000
        & > div
            position: absolute
            top: 50%
            left: 50%
            transform: translate(-50%, -50%)
        .loading
            .loading-wheel
                width: 100px
                height: 100px
                background: #dfc384
                border-radius: 100%
                position: relative
                .spinner
                    width: 100%
                    height: 100%
                    background: url('./assets/images/loadingCircles.png') 100%/100% no-repeat
                    background-position: -1px -1px
                    animation: 2s steps(8) rotate infinite
        .click-to-play
            .start-btn
                width: 100px
                height: 100px
                background: #b5d16d
                border-radius: 100%
                position: relative
                cursor: pointer
                & > i
                    color: #fff
                    font-size: 4em
                    line-height: 1em
                    position: absolute
                    top: 51%
                    left: 54%
                    transform: translate(-50%, -50%)
</style>